import { Component, OnInit, ViewEncapsulation } from '@angular/core';

export interface Menu {
  name:string,
  link:string,
  disabled: boolean
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None
})

export class HeaderComponent implements OnInit {
  menuState: boolean = false;

  items:Menu[]= [
    {name:"Home", link:"home", disabled:false},
    {name:"Html5", link:"articles/front-end/html5", disabled:false},
    //{name:"Css", link:"home"},
    {name:"Angular", link:"articles/front-end/angular", disabled:false},
    {name:"Altro", link:"articles/other/tecnologia", disabled:false},
    {name:"NodeJs", link:"articles/back-end/nodejs", disabled:true},
  ]

  constructor() { }

  ngOnInit(): void {
  }

  openMenuMobile() {
    this.menuState = !this.menuState;
  }

}
